
export class EmployeeSelectionFilters {
    Trabajador = '';
    AttributeList = [];
    EmpresaID: number;
    BajasOrdern = '';
    Alarmas = '';
    BajasDeEmpresa = false;
    EmpresaSelec = false;
    Consentimiento = '';
    Ordern = '0';
    PageIndex = 0;
    PageSize = 0;
    ColumnsList:any;
}

export class EmployeeSelectionResult {
    id: number;
    empresa: string;
    trabajadorId: number;
    referencia: string;
    nif: string;
    bloq: string;
    nombre: string;
    edad: number;
    jornada: string;
    atributos: string;
    absentismo: string;
    bradford: string;
    aviso: string;
    alarmas: string;
}
